import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ButtonNavigationComponent } from 'src/app/features/shared/controls/container/button-navigation/button-navigation.component';
import { IconsModule } from 'src/app/features/shared/icons/icons.module';
import { SharedModule } from 'src/app/features/shared/shared.module';

import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { LayoutService } from 'src/app/core/layout/layout.service';
import { ThemeService } from 'src/app/core/theming/theme.service';
import { LanguageService, TAppLang } from 'src/app/infrastructure/i18n/language.service';
import { FadeInFadeOutValueDirective } from "src/app/infrastructure/directives/fade-in-fade-out-value.directive";
import { NavigationHistoryComponent } from 'src/app/features/shared/navigation-history/container/navigation-history/navigation-history.component';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    standalone: true,
    imports: [
    SharedModule,
    ButtonNavigationComponent,
    IconsModule,
    NavigationHistoryComponent,
    FadeInFadeOutValueDirective
],
    styleUrls: ['../../../core.scss', './menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
    protected _theme = inject(ThemeService);
    protected _language = inject(LanguageService);
    private __layout = inject(LayoutService);

    private itemSubscr: Subscription;
    private userSubscr: Subscription;

    public email: string;
    public menuItems: IPageData[];

    // Vlag-icoon + label per taal voor de taal-toggle.
    protected readonly _flagSrc: Record<TAppLang, string> = {
        nl: '/assets/flags/nl.svg',
        en: '/assets/flags/gb.svg',
    };
    protected readonly _langLabel: Record<TAppLang, string> = {
        nl: 'Nederlands',
        en: 'English',
    };

    constructor(
        // private accountService: AccountFormModelService,
        // private layoutService: LayoutService,
        // private menuService: MenuService
    ) {}

    ngOnInit(): void {
        // this.userSubscr = this.accountService.dtoModel$.subscribe(dtoModel => (this.email = dtoModel?.email));
        // this.itemSubscr = this.menuService.menuItems$.subscribe(list => this.menuItems = list);
    }

    // Quick light/dark switch available wherever the drawer is opened.
    emit_colorMode_toggle(): void {
        this._theme.SetColorMode(this._theme.ColorMode$$() === 'dark' ? 'light' : 'dark');
    }

    // Two languages, so a single toggle next to the colour-mode switch suffices.
    emit_language_toggle(): void {
        this._language.setLanguage(this._language.Current$$() === 'nl' ? 'en' : 'nl');
    }

    protected _languageTooltip(): string {
        return this._language.Current$$() === 'nl' ? 'Switch to English' : 'Schakel naar Nederlands';
    }

    toggleSidenav() {
        this.__layout.toggleSideNav();
    }

    ngOnDestroy() {
        this.itemSubscr?.unsubscribe();
        this.userSubscr?.unsubscribe();
    }
}
